import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Confirm, Dimmer, Loader, Modal } from 'semantic-ui-react';
import { ExpenseProgram } from './ExpenseProgram';
import { AppContext } from '../../context/app/appContext';
import { getCurrentPageRoutePart } from "../../utilities/Utility";
import DatePicker from "react-datepicker";
import axios from "axios";
import { useHistory, Switch, Route } from 'react-router-dom'

export const ExpenseProgramManagement = (props) => {

    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    let API = axios.create({ baseURL, headers: { 'Authorization': `Bearer ${accessToken}` }, });

    const history = useHistory();

    const dimmer = 'blurring';
    const [showSaveChangesModal, setShowSaveChangesModal] = useState(false);
    const [expensePrograms, setExpensePrograms] = useState([]);
    const appContext = useContext(AppContext);

    const [newExpenseProgramName, setNewExpenseProgramName] = useState('');
    const currentDate = new Date();
    const [newExpenseProgramStartDate, setNewExpenseProgramStartDate] = useState(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); return temp;});
    const [newExpenseProgramEndDate, setNewExpenseProgramEndDate] = useState(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); temp.setDate(-15); temp.setMonth(temp.getMonth() + 2); temp.setDate(0); return temp; });
    const [showNewExpenseProgramInlineForm, setShowNewExpenseProgramInlineForm] = useState(false);

    const [endDateEnabled, setEndDateEnabled] = useState(false);
    const [invalidDateRange, setInvalidDateRange] = useState(false);
    const [monthlyEndDates, setMonthlyEndDates] = useState([]);
    const [monthlyStartDates, setMonthlyStartDates] = useState([]);

    const [currentlyEditingExpenseProgramId, setCurrentlyEditingExpenseProgramId] = useState('');
    const [idToDelete, setIdToDelete] = useState('');
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [infoModalText, setInfoModalText] = useState('');
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);

    const [activeProgramsSection, setActiveProgramsSection] = useState(false);

    console.log("Current expenses");
    console.log(appContext.expensePrograms)

    useEffect(() => {
        let startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        let endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);;
        setNewExpenseProgramStartDate(startDate);
        endDate.setMonth(endDate.getMonth() + 1)
        setNewExpenseProgramEndDate(endDate.setDate(0))
    }, [])

    useEffect(() => {
        appContext.setLoading();
        (async function loadExpenseCategories() {
            await appContext.loadExpenseCategories();
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
                await appContext.setEmployees();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        (async function loadExpensePrograms() {
            await appContext.loadExpensePrograms();
        })();
    }, []);

    useEffect(() => {
        setMonthlyEndDates(getMonthlyEndDates(newExpenseProgramStartDate));
    }, [newExpenseProgramStartDate])

    useEffect(() => {
        setMonthlyEndDates(getMonthlyEndDates(newExpenseProgramStartDate));
    }, [])

    useEffect(() => {
        setMonthlyStartDates(getMonthlyStartDates(newExpenseProgramStartDate));
    }, [])

    useEffect(() => {
        setExpensePrograms(appContext.expensePrograms);
        console.info({ expensePrograms });
    }, [appContext.expensePrograms]);


    // useEffect(() => {
    //     setCurrentExpensePrograms(expensePrograms)
    // }, [expensePrograms]);

    useEffect(() => {
        const programSection = getCurrentPageRoutePart();
        programSection === 'active' ? setActiveProgramsSection(true) : setActiveProgramsSection(false);
    }, [getCurrentPageRoutePart()]);

    useEffect(() => {
        const invalidDateRange = newExpenseProgramEndDate <= newExpenseProgramStartDate || newExpenseProgramEndDate === currentDate;
        console.info({ invalidDateRange });
        invalidDateRange ? setInvalidDateRange(true) : setInvalidDateRange(false);
    }, [newExpenseProgramStartDate, newExpenseProgramEndDate]);

    const addNewProgramHandler = async (event) => {
        event.preventDefault();
        console.table(newExpenseProgramName, newExpenseProgramStartDate, newExpenseProgramEndDate);

        var tempStartDate = newExpenseProgramStartDate
        tempStartDate.setHours(newExpenseProgramStartDate.getHours() - (newExpenseProgramStartDate.getTimezoneOffset() / 60))
        var tempEndDate = newExpenseProgramEndDate;
        tempEndDate.setHours(newExpenseProgramEndDate.getHours() - (newExpenseProgramEndDate.getTimezoneOffset() / 60))
        tempEndDate.setDate(newExpenseProgramEndDate.getDate() + 1)

        console.table(newExpenseProgramName, tempStartDate, tempEndDate);

        await appContext.createExpenseProgram({
            name: newExpenseProgramName,
            startDate: tempStartDate,
            endDate: tempEndDate,
            neverExpire: false,
        });

        await axios.post(baseURL + '/recentActions', { task: "Expense Program " + newExpenseProgramName + " created" }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })

        setNewExpenseProgramName('');
        // let startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        // let endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        // setNewExpenseProgramStartDate(startDate);
        // endDate.setMonth(endDate.getMonth() + 1)
        // setNewExpenseProgramEndDate(endDate.setDate(0))
        setNewExpenseProgramStartDate(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); return temp;});
        setNewExpenseProgramEndDate(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); temp.setDate(-15); temp.setMonth(temp.getMonth() + 2); temp.setDate(0); return temp; });
        setShowNewExpenseProgramInlineForm(false);
    };

    const editProgramHandler = (event) => {
        setShowSaveChangesModal(true);
    };

    const saveChangesModalCloseHandler = () => {
        setShowSaveChangesModal(false);
    };

    const handleExpenseProgramSelectionChange = (expenseProgramId, selected) => {
        const selectedExpensePrograms = expensePrograms.map(expenseProgram => {
            if (expenseProgram.id === expenseProgramId) return {
                ...expenseProgram,
                selected: !selected,
            }; // TODO: should be toggle
            return expenseProgram;
        });
        console.clear();
        console.table(selectedExpensePrograms);
        setExpensePrograms(selectedExpensePrograms);
    };

    const checkIfAlreadyEditing = (programId) => {
        console.info(`checkIfAlreadyEditing programId: ${programId}`);
        if (currentlyEditingExpenseProgramId !== '' || showNewExpenseProgramInlineForm) {
            setInfoModalText(`Please save or cancel current updates.`);
            setShowInfoModal(true);
            return true;
        } else {
            setCurrentlyEditingExpenseProgramId(programId);
            return false;
        }
    }

    const handleResetEditInProgress = () => {
        setCurrentlyEditingExpenseProgramId('');
    }

    const handleCancelDelete = (programId) => {
        console.info(`canceled program delete... ${programId}`);

        setShowConfirmDeleteModal(false);
    }

    const handleConfirmDelete = async () => {
        console.info(`confirmed program delete...`);
        setShowConfirmDeleteModal(false);
        appContext.setLoading();
        // const response = await API.post(`/delete-expense-program`, {programId: idToDelete}).catch(error => {
        //     console.info({error});
        //     if (error.isAxiosError && error.response.data && error.response.data.status) {
        //         console.info(error.response.data.status);
        //         const {code, message} = error.response.data.status;
        //         console.info({code});
        //         setInfoModalText(message);
        //         setShowInfoModal(true);
        //         appContext.setLoading(false);
        //         return error.response.data.status;
        //     } else {
        //         setInfoModalText(`There was an error. Please try again later.`);
        //         setShowInfoModal(true);
        //         appContext.setLoading(false);
        //     }
        // });
        // if (response && response.data && response.data.status) {
        //     const {code, message} = response.data.status;
        //     console.info({code, message});
        //     setInfoModalText(message);
        //     setShowInfoModal(true);
        //     if (code === `expenseProgram/deleted`) appContext.deleteExpenseProgram(idToDelete);
        //     appContext.setLoading(false);
        // }
        await appContext.deleteExpenseProgram(idToDelete);
        setInfoModalText("Program Deleted");

        var deleted = expensePrograms.filter(program => { return program.id === idToDelete })
        var temp = expensePrograms.filter(program => { return program.id !== idToDelete })

        await axios.post(baseURL + '/recentActions', { task: 'Expense Program: ' + deleted.name + " Deleted" }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })

        setExpensePrograms(temp);
    }

    const handleDelete = (programId) => {
        setIdToDelete(programId);
        console.info(`Deleting Perk Program with ID: ${programId}`);
        setShowConfirmDeleteModal(true);
    }

    /*const getMonthlyCycleDates = () => {
        const forMonths = 12;
        const monthlyDates = [];
        const currentDate = new Date();
        let currentMonth = currentDate.getMonth();
        while (currentMonth <= forMonths){
            monthlyDates.push(currentDate.setDate(currentDate.getMonth() + 1));
            currentMonth++;
        }
        console.info({monthlyDates});
        return monthlyDates;
    }*/

    const newProgramCancelHandler = () => {
        var x = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        console.info({x})
        var y = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        y.setDate(-15);
        y.setMonth(y.getMonth() + 2);
        y.setDate(0);
        console.info({y})
        setNewExpenseProgramStartDate(x)
        setNewExpenseProgramEndDate(y);

        setNewExpenseProgramName('');
        setShowNewExpenseProgramInlineForm(false)
    }

    const getMonthlyEndDates = (date) => {
        let startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const totalMonths = 12;
        startDate.setDate(0)
        startDate.setDate(startDate.getDate() + 15)
        startDate.setMonth(startDate.getMonth() + 1)
        let tempDate = startDate.setDate(0)
        const validEndDates = [tempDate];
        for (let i = 1; i <= totalMonths; i++) {
            startDate.setDate(startDate.getDate() + 15)
            startDate.setMonth(startDate.getMonth() + 1)
            let nextMonthDate = startDate.setDate(0)
            validEndDates.push(nextMonthDate);
        }
        return validEndDates;
    }

    const getMonthlyStartDates = (date) => {
        let startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const totalMonths = 12;
        startDate.setDate(1)
        const validEndDates = [Date.parse(startDate)];
        for (let i = 1; i <= totalMonths; i++) {
            // startDate.setDate(startDate.getDate() + 15)
            startDate.setMonth(startDate.getMonth() + 1)
            let nextMonthDate = startDate.setDate(1)
            validEndDates.push(nextMonthDate);
        }
        console.log(validEndDates)
        return validEndDates;
    }

    const onAddExpenses = (programId) => {
        history.push(`/programs/expense-programs/${programId}/add-expenses`);
    };

    const AddNewProgramForm = <>
        <tr key="0" className="center aligned" style={{ backgroundColor: 'rgba(238, 241, 243, 1)' }}>
            <td><input type="text" className="ui input" value={newExpenseProgramName} onChange={e => setNewExpenseProgramName(e.target.value)} required /></td>
            <td></td>
            <td><DatePicker className="ui input" selected={newExpenseProgramStartDate} minDate={monthlyStartDates[0]}
                onChange={date => setNewExpenseProgramStartDate(date)} includeDates={monthlyStartDates} /></td>
            <td><Checkbox checked={endDateEnabled} onChange={e => setEndDateEnabled(!endDateEnabled)} /></td>
            <td>{endDateEnabled && (
                <DatePicker className="ui input" selected={newExpenseProgramEndDate} minDate={monthlyEndDates[0]} onChange={date => setNewExpenseProgramEndDate(date)} includeDates={monthlyEndDates} />
            )}</td>
            <td>monthly</td>
            <td className="right aligned">
                <button className="ui button center aligned" onClick={newProgramCancelHandler}>Cancel</button>
                <button className="ui button primary center aligned" onClick={addNewProgramHandler}
                    disabled={!newExpenseProgramName.length || invalidDateRange}>Save
                </button>
            </td>
        </tr>
    </>;

    const activePrograms = (<>{showNewExpenseProgramInlineForm && AddNewProgramForm}
        {expensePrograms.map(expenseProgram => (expenseProgram.active && <ExpenseProgram key={expenseProgram.id} {...expenseProgram}
            onEdit={editProgramHandler}
            onDelete={handleDelete}
            resetEditInProgress={handleResetEditInProgress}
            editInProgress={checkIfAlreadyEditing}
            onAddExpenses={onAddExpenses}
            onSelect={handleExpenseProgramSelectionChange} expenseProgram={expenseProgram} />))}</>);

    const expiredPrograms = (expensePrograms.map(expenseProgram => (!expenseProgram.active && <ExpenseProgram key={expenseProgram.id} {...expenseProgram} />)));

    return (
        <div className="sub-page" id="expense-program-management" style={{ width: '90vw' }}>

            {appContext.loading && (<Dimmer active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>)}

            {activeProgramsSection && (<div className="ui two column grid" style={{ width: '90vw' }}>
                <div className="column">
                    {/*<a href="#top" className="ui button" onClick={editProgramHandler}><i
                        className="pencil alternate icon"/>Edit</a>*/}
                </div>

                <div className="column right aligned">
                    <button className={showNewExpenseProgramInlineForm || currentlyEditingExpenseProgramId !== '' ? 'ui button disabled' : 'ui button'}
                        onClick={e => setShowNewExpenseProgramInlineForm(true)}><i className="plus alternate icon" />Add Program
                    </button>
                </div>
            </div>)}

            <table className="ui table teams" style={{ backgroundColor: 'transparent' }}>
                <thead style={{ backgroundColor: 'transparent' }}>
                    <tr className="center aligned" style={{ backgroundColor: 'transparent' }}>
                        <th style={{ backgroundColor: 'transparent' }}>Program Name</th>
                        <th width='15%' style={{ backgroundColor: 'transparent' }}>Teams</th>
                        <th style={{ backgroundColor: 'transparent' }}>Start Date <i className="calendar alternate icon" /></th>
                        {activeProgramsSection && <th style={{ backgroundColor: 'transparent' }}>End Date On</th>}
                        <th style={{ backgroundColor: 'transparent' }}>End Date <i className="calendar alternate icon" /></th>
                        <th style={{ backgroundColor: 'transparent' }}>Frequency</th>
                        {activeProgramsSection && (<th style={{ backgroundColor: 'transparent' }}></th>)}
                    </tr>
                </thead>
                <tbody>
                    {activeProgramsSection && activePrograms}
                    {!activeProgramsSection && expiredPrograms}
                </tbody>
            </table>

            <footer>
            </footer>

            <Modal dimmer={dimmer} open={showSaveChangesModal}
                size="mini" onClose={saveChangesModalCloseHandler}>
                <Modal.Content><p>Save changes in this Expense Program?</p>
                </Modal.Content>
                <Modal.Actions className="center aligned">
                    <Button onClick={saveChangesModalCloseHandler}>Cancel</Button>
                    <Button className="primary" content="Save"
                        onClick={saveChangesModalCloseHandler} />
                </Modal.Actions>
            </Modal>

            <Confirm className="confirm-modal" open={showConfirmDeleteModal}
                content='Are you sure to delete this Expense Program?'
                cancelButton='Cancel'
                confirmButton="Delete"
                onCancel={handleCancelDelete} onConfirm={handleConfirmDelete} />

            <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                <Modal.Content><p>{infoModalText}</p></Modal.Content>
                <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
            </Modal>

        </div>
    );
};
